import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import CheckoutLinkFormContainer from './CheckoutLinkFormContainer';
import Button from '../../../core/form/Button';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';

const CheckoutLinkFormScene = (props) => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: `${props.params.checkoutLinkId ? 'Edit Checkout link' : 'Create Checkout link'}`,
        },
      ]}
    />
    <Card
      title={props.params.countryId ? 'Edit Checkout link' : 'Create Checkout link'}
      actions={<Button icon="arrow-left" label="Back" type="default" onClick={() => browserHistory.goBack()} />}
    >
      <CheckoutLinkFormContainer countryId={props.params.checkoutLinkId} />
    </Card>
  </div>
);

CheckoutLinkFormScene.propTypes = {
  params: PropTypes.shape({
    checkoutLinkId: PropTypes.string,
  }),
};

CheckoutLinkFormScene.defaultProps = {
  params: null,
};

export default CheckoutLinkFormScene;
